import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'start-interview',
    templateUrl: './start.component.html',
    standalone: false
})
export class StartComponent implements OnInit {

    constructor() {}

    ngOnInit() {}

}